export default __webpack_public_path__ + "static/media/logo-navy-with-tagline@3x.c5bd9c18.png";